import clsx from 'clsx';
import { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combination of `clsx` and `twMerge`, constructs `className` strings conditionally
 * and merges Tailwind CSS classes without style conflicts.
 *
 * Adapted from https://github.com/shadcn-ui/ui/blob/main/apps/www/lib/utils.ts#L4
 */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
